const targetTransactionsDimensionConfig = {
  dimensionName: 'Target Transactions',
  stepperDimensionName: 'Add target transactions',
  stepperDimensionTitle: 'Target Transactions',
  customComponentName: 'targetTransactions',
  inputs: [],
};

export default targetTransactionsDimensionConfig;
